import CreateOrChangeTariffFeatureForm from './CreateOrChangeTariffFeatureForm';

export default CreateOrChangeTariffFeatureForm;
